import { Rank } from "./rank";

export class Ranks {
    public country?: Rank
    public category?: Rank
    public global?: Rank
}